module.exports = __webpack_public_path__ + "c40323f.worker.js"